// @flow

import get from 'lodash/get';

import type { TranslatorProps } from '@gandi/translate';

import type { RenewableProduct } from '../types';

export const mapFiltersToTypes = {
  all: ['domain', 'simple-hosting', 'issued-cert', 'server'],
  domain: ['domain'],
  simplehosting: ['simple-hosting'],
  cloud: ['server'],
  certificate: ['issued-cert'],
};

export const isTrial = (resource: RenewableProduct): boolean => {
  const dateCreated = resource.meta_data.started_at;
  const dateEnd = resource.meta_data.expires_at;
  const start = new Date(dateCreated);
  const end = new Date(dateEnd);

  const oneHour = 60 * 60 * 1000;
  const tenDays = 10 * 24 * oneHour;
  // this is a trial if time between creation and end is 10 days.
  // given daylight saving uncertainity, we add a full hour.
  return end.getTime() - start.getTime() <= tenDays + oneHour;
};

export function isRestorable(renewableProduct: RenewableProduct): boolean {
  const restorable =
    renewableProduct.meta_data &&
    renewableProduct.meta_data.restorable !== undefined
      ? renewableProduct.meta_data.restorable
      : renewableProduct.status === 'deleted';
  return restorable;
}

export function isRenewable(info: mixed): boolean {
  const durations = get(info, 'durations') || [];
  return !!(
    !get(info, 'prohibited') &&
    get(info, 'in_renew_period') &&
    // $FlowFixMe T54746
    ('renewable' in (info || {}) ? info.renewable : true) &&
    durations.length > 0
  );
}

export function getRenewableProductIdentifier(
  resource: RenewableProduct,
): string {
  let identifier;

  switch (resource.type) {
    case 'domain':
      identifier = resource.name;
      break;
    case 'simple-hosting':
      identifier = resource.id;
      break;
    default:
      identifier = resource.name;
      break;
  }

  return identifier;
}

export function getExpireDataInfo(
  date: string,
  translator: TranslatorProps,
): { expireDate: any, expireTheme: string, isExpired: boolean } {
  const { __ } = translator;
  const endDate = translator.localize(date);
  const diffHours = endDate.diff(Date.now(), 'hours');
  const diffDays = endDate.diff(Date.now(), 'days');
  const expirationDate = translator.formatDate(endDate, 'll');

  let expireDate = __('Expires %(expirationDate)s', { expirationDate });
  let expireTheme = 'warning';
  let isExpired = false;

  if (diffHours < 0) {
    expireDate = __('Expired on %(expirationDate)s', { expirationDate });
    expireTheme = 'danger';
    isExpired = true;
  } else if (diffDays < 15) {
    expireDate = __('Expires in %(diffDays)s days', { diffDays });
    expireTheme = 'danger';
  }

  return { expireDate, expireTheme, isExpired };
}
